import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import Divider from "@mui/material/Divider";

const services = [
  {
    title: "Transparent Processes:",
    details: "Clear eligibility criteria and application guidelines.",
  },
  {
    title: "Support for Early and Growth Stages: ",
    details:
      "Funding for early-stage innovations and proven projects ready to scale.",
  },
  {
    title: "Long-Term Impact: ",
    details:
      "Resources and mentorship to help grantees achieve lasting community transformation.",
  },
];

const Commitment = () => {
  return (
    <Box
      margin={{ xs: "25% 0% 15% 0%", sm: "5% 0% 5% 0%" }}
      data-aos={"fade-up"}
    >
      <Typography
        variant="h3"
        fontWeight={700}
        paddingBottom={{ xs: "4%", sm: "4%" }}
        textAlign={"center"}
        color={"#39484E"}
      >
        {" "}
        Our Commitment to Grantees
      </Typography>
      <Box
        display={"flex"}
        justifyContent={"space-between"}
        // alignItems={"center"}
        flexWrap={"wrap"}
        width={"100%"}
      >
        <Box
          width={{ xs: "100%", sm: "48%" }}
          paddingRight={{ xs: "0%", sm: "4%" }}
        >
          <Typography
            variant="h5"
            fontWeight={700}
            paddingBottom={{ xs: "4%", sm: "2%" }}
            textAlign={"left"}
            color={"#39484E"}
          >
            {" "}
            Although AIR Fund is not yet accepting applications, we are
            committed to building a robust and accessible process for future
            funding opportunities. Prospective applicants will benefit from:
          </Typography>
        </Box>
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          color={"#39484E"}
        />
        <Box
          width={{ xs: "100%", sm: "48%" }}
          paddingLeft={{ xs: "0%", sm: "4%" }}
        >
          {services.map((data, index) => (
            <Box display={"flex"} alignItems={"flex-start"} key={index}>
              <Typography
                variant="h4"
                fontWeight={700}
                paddingRight={"4%"}
                textAlign={"left"}
                color={"#948979"}
              >
                {" "}
                &#8226;
              </Typography>

              <Typography
                variant="body1"
                fontWeight={400}
                paddingBottom={{ xs: "4%", sm: "2%" }}
                textAlign={"left"}
                color={"#39484E"}
              >
                <Typography
                  component={"span"}
                  variant="body1"
                  fontWeight={700}
                  paddingBottom={{ xs: "4%", sm: "2%" }}
                  textAlign={"left"}
                  color={"#213555"}
                >
                  {data.title}{" "}
                </Typography>
                {data.details}
              </Typography>
            </Box>
          ))}
        </Box>
      </Box>
    </Box>
  );
};

export default Commitment;
